import { useLocation } from "react-router-dom";

export function useQueryParam<T>(): { [k: string]: any } | T {
  const location = useLocation();
  const search = location.search;
  return Object.fromEntries(new URLSearchParams(search).entries());
}
